// Hook for accessing and filtering Gitcha's available cities in search dropdowns
import { useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllAvailableCities } from "../actions/locations";
import {
  filterAvailableCities,
  FEATURED_CITIES,
} from "../constants/cityConfig";

const useAvailableCities = () => {
  const dispatch = useDispatch();
  const allCities = useSelector((state) => state.locations.allCities);
  const allCitiesLoaded = useSelector(
    (state) => state.locations.allCitiesLoaded
  );

  useEffect(() => {
    if (!allCitiesLoaded && allCities.length === 0) {
      dispatch(fetchAllAvailableCities());
    }
  }, [dispatch, allCitiesLoaded, allCities.length]);

  const filterCities = useCallback(
    (query) => filterAvailableCities(allCities, query),
    [allCities]
  );

  // [US-003] Filter featured cities by tenant's location restriction states
  const featuredCities = useMemo(() => {
    const tenantConfig = window.__TENANT_CONFIG__;
    const restrictedStates = tenantConfig?.locationRestriction?.states;
    const cities = restrictedStates?.length > 0
      ? FEATURED_CITIES.filter((fc) =>
          restrictedStates.includes(fc.state.toUpperCase())
        )
      : FEATURED_CITIES;
    return cities.map((fc) => ({ ...fc, isFeatured: true }));
  }, []);

  return { allCities, featuredCities, filterCities, allCitiesLoaded };
};

export default useAvailableCities;
